import styles from './Background.module.sass'

export const Background = () => {
  return (
    <div className={styles.background}>
      <div className={styles.startGrid}></div>
      <div className={styles.grid}></div>
    </div>
  )
}